"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("../../constants");
const btclightclientquery = __importStar(require("../../generated/babylon/btclightclient/v1/query"));
const incentivequery = __importStar(require("../../generated/babylon/incentive/query"));
const createBTCClient = ({ incentive, bank, btcLight }) => ({
    /**
       * Gets the rewards of the user's account.
       * @param {string} address - The address to get the rewards of.
       * @returns {Promise<number>} - The rewards of the address.
       */
    async getRewards(address) {
        try {
            const req = incentivequery.QueryRewardGaugesRequest.fromPartial({
                address,
            });
            const rewards = await incentive.RewardGauges(req);
            if (!rewards || !rewards.rewardGauges) {
                return 0;
            }
            const coins = rewards.rewardGauges[constants_1.REWARD_GAUGE_KEY_BTC_DELEGATION]?.coins;
            if (!coins) {
                return 0;
            }
            const withdrawnCoins = rewards.rewardGauges[constants_1.REWARD_GAUGE_KEY_BTC_DELEGATION]?.withdrawnCoins.reduce((acc, coin) => acc + Number(coin.amount), 0) || 0;
            return (coins.reduce((acc, coin) => acc + Number(coin.amount), 0) - withdrawnCoins);
        }
        catch (error) {
            // If error message contains "reward gauge not found", silently return 0
            // This is to handle the case where the user has no rewards, meaning
            // they have not staked
            if (error instanceof Error &&
                error.message.includes("reward gauge not found")) {
                return 0;
            }
            throw new Error(`Failed to fetch rewards for ${address}`, {
                cause: error,
            });
        }
    },
    /**
     * Gets the balance of an address in the Babylon chain.
     * @param {string} address - The address to get the balance of.
     * @param {string} denom - The denom of the balance to get.
     * @returns {Promise<number>} - The balance of the address.
     */
    async getBalance(address, denom = "ubbn") {
        try {
            const balance = await bank.balance(address, denom);
            return Number(balance?.amount ?? 0);
        }
        catch (error) {
            throw new Error(`Failed to fetch balance for ${address}`, {
                cause: error,
            });
        }
    },
    /**
     * Gets the tip of the Bitcoin blockchain.
     * @returns {Promise<BTCHeaderInfoResponse>} - The tip of the Bitcoin blockchain.
     */
    async getBTCTipHeight() {
        try {
            const req = btclightclientquery.QueryTipRequest.fromPartial({});
            const { header } = await btcLight.Tip(req);
            return Number(header?.height ?? 0);
        }
        catch (error) {
            throw new Error(`Failed to fetch BTC tip height`, {
                cause: error,
            });
        }
    }
});
exports.default = createBTCClient;
//# sourceMappingURL=btc.js.map